import { Link } from 'react-router-dom';
import { ShieldCheck } from '@phosphor-icons/react';
import BrandLogo, { useBrand } from '../Brand';
import SocialIcon from '../SocialIcon';
import { useSettings } from '../../context/SettingsContext';
import { activeSocials, SOCIAL_KINDS, socialLink } from '../../lib/socials';

const Footer = () => {
  const { name } = useBrand();
  const { site } = useSettings();
  const year = new Date().getFullYear();
  const socials = activeSocials(site);
  return (
    <footer className="border-t border-white/5 bg-bh-canvas">
      <div className="max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-8 py-8 sm:py-10 grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center mb-4">
            <BrandLogo className="h-10 w-auto object-contain" />
          </div>
          <p className="text-sm text-gray-400 leading-relaxed max-w-sm">
            Türkiye'nin en güvenilir sponsor ve bonus platformu. Anlaşmalı sponsorlarımızdan özel bonuslar kazanın, görevleri tamamlayın ve puanlarınızı ödüle dönüştürün.
          </p>
          {socials.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 mt-5">
              {socials.map((s, i) => (
                <a
                  key={`${s.kind}-${i}`}
                  href={socialLink(s)}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.label || SOCIAL_KINDS.find((k) => k.id === s.kind)?.label || s.kind}
                  className="w-9 h-9 rounded-lg btn-ghost flex items-center justify-center text-gray-400 hover:text-bh-accent"
                >
                  <SocialIcon kind={s.kind} />
                </a>
              ))}
            </div>
          )}
        </div>
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-gray-500 mb-4">Platform</h4>
          <ul className="space-y-2.5 text-sm">
            {[['Sponsorlar', '/'], ['Görevler', '/gorevler'], ['Puan Marketi', '/market'], ['Turnuvalar', '/turnuvalar']].map(([label, path]) => (
              <li key={path}><Link to={path} className="text-gray-400 hover:text-bh-accent transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-gray-500 mb-4">Kazan</h4>
          <ul className="space-y-2.5 text-sm">
            {[['Şans Çarkı', '/cark'], ['Promo Kod', '/promokod'], ['Haberler', '/haberler']].map(([label, path]) => (
              <li key={path}><Link to={path} className="text-gray-400 hover:text-bh-accent transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <p className="text-xs text-gray-600">© {year} {name}. Tüm hakları saklıdır. 18+ Sorumlu oyun.</p>
          <div className="flex items-center gap-1.5 text-xs text-gray-500">
            <ShieldCheck className="w-3.5 h-3.5 text-bh-emerald" /> SSL Güvenli Platform
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
